import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex);
import createPersistedState from 'vuex-persistedstate'
import {version} from "../package";


const store = new Vuex.Store({
  state: {
    appVersion: version,
    sidebarMainExpanded: true,
    sidebarMiniActive: false,
    sidebarMainAccordionMode: false,
    sidebarMainScrollToActive: false,
    cardFixed: false,
    headerExpanded: false,
    pageFixed: false,
    appTheme: 'theme-default',
    offcanvasPresent: false,
    offcanvasExpanded: false,
    progressOverlay: false,
    dashRoleId:'',
    partnerId:'',
    auth: {
      status: false,
      id: '',
      first_name: '',
      middle_name: '',
      name: '',
      last_name: '',
      email: '',
      user_name: '',
      user_key: '',
      avatar: '',
      company_name: '',
      website: '',
      role_id: '',
      role: '',
      roles: []
    },
    sauth: {
      status: false,
      id: '',
      first_name: '',
      middle_name: '',
      name: '',
      last_name: '',
      email: '',
      user_name: '',
      user_key: '',
      avatar: '',
      company_name: '',
      website: '',
      role_id: '',
      role: '',
      roles: []
    },
    sauthToken: '',
    config: {},
    isNewPartner: false,
  },
  mutations: {

    setDashRoleId(state,roleId){
      state.dashRoleId = roleId;
    },
    resetDashRoleId(state){
      state.dashRoleId = '';
    },

    setPartnerId(state,partnerId){
      state.partnerId = partnerId;
    },
    resetPartnerId(state){
      state.partnerId = '';
    },


    setAuthUserDetail (state, auth) {
      for (let key of Object.keys(auth)) {
        state.auth[key] = auth[key] !== null ? auth[key] : '';
      }
      if ('avatar' in auth)
        state.auth.avatar = auth.avatar !== null ? auth.avatar : '';
      state.auth.status = true;
      state.auth.roles = auth.roles;
    },
    resetAuthUserDetail (state) {
      for (let key of Object.keys(state.auth)) {
        state.auth[key] = '';
      }
      state.auth.status = false;
      state.auth.roles = [];
      Vue.cookie.delete('auth_token');
      axios.defaults.headers.common['Authorization'] = null;
    },

    setAdminUser (state) {
      console.log("auth:: ", state.auth);
      for (let key of Object.keys(state.auth)) {
        state.sauth[key] = state.auth[key] !== null ? state.auth[key] : '';
      }
      if ('avatar' in state.auth)
        state.sauth.avatar = state.auth.avatar !== null ? state.auth.avatar : '';
      state.sauth.status = true;
      state.sauth.roles = state.auth.roles;
    },

    resetAdminUser (state) {
      for (let key of Object.keys(state.sauth)) {
        state.sauth[key] = '';
      }
      state.sauth.status = false;
      state.sauth.roles = [];
      Vue.cookie.delete('auth_token');
      axios.defaults.headers.common['Authorization'] = null;
    },

    setSidebarMiniActive (state, active) {
      state.vxSidebarMiniActive = active;
    },

    sidebarMainToggle (state, expanded) {
      if(typeof expanded !== 'undefined') {
        state.sidebarMainExpanded = expanded
      } else {
        state.sidebarMainExpanded = !state.sidebarMainExpanded
      }
    },
    sidebarMainAccordionModeToggle (state) {
      state.sidebarMainAccordionMode = !state.sidebarMainAccordionMode
    },
    sidebarMainScrollToActiveToggle (state) {
      state.sidebarMainScrollToActive = !state.sidebarMainScrollToActive
    },
    setCardFixed (state, fixed) {
      state.cardFixed = fixed
    },
    setHeaderExpanded (state, expanded) {
      state.headerExpanded = expanded
    },
    setPageFixed (state, fixed) {
      state.pageFixed = fixed
    },
    setAppTheme (state, theme) {
      state.appTheme = theme
    },
    setOffcanvasPresent (state, present) {
      state.offcanvasPresent = present
    },
    offcanvasToggle (state, active) {
      state.offcanvasExpanded = active
    },
    toggleProgressOverlay (state, active) {
      state.progressOverlay = active
    },
    setConfig (state, config) {
      for (let key of Object.keys(config)) {
        state.config[key] = config[key];
      }
    },
    resetConfig (state) {
      for (let key of Object.keys(state.config)) {
        delete state.config[key];
      }
    },
    setNewPartner (state, bValue) {
      state.isNewPartner = bValue;
    },
    resetNewPartner (state) {
      state.isNewPartner = false;
    },
    setAdminToken (state, token) {
      state.sauthToken = token;
    },
    resetAdminToken (state) {
      state.sauthToken = '';
    }
  },
  actions: {
    setDashRoleId ({ commit }, roleId) {
      commit('setDashRoleId',roleId);
    },
    resetDashRoleId ({ commit }) {
      commit('resetDashRoleId');
    },

    setPartnerId ({ commit }, partnerId) {
      commit('setPartnerId',partnerId);
    },
    resetPartnerId ({ commit }) {
      commit('resetPartnerId');
    },

    
    setAuthUserDetail ({ commit }, auth) {
      commit('setAuthUserDetail',auth);
    },
    resetAuthUserDetail ({commit}){
      commit('resetAuthUserDetail');
    },
    setAdminUser ({ commit }, auth) {
      commit('setAdminUser',auth);
    },
    resetAdminUser ({commit}){
      commit('resetAdminUser');
    },
    setConfig ({ commit }, data) {
      commit('setConfig',data);
    },
    resetConfig({ commit }) {
      commit('resetConfig');
    },

    setNewPartner( {commit} ) {
      commit('setNewPartner');
    },

    resetNewPartner( {commit} ) {
      commit('resetNewPartner');
    },

    setAdminToken( {commit}, token ) {
      commit('setAdminToken', token);
    },

    resetAdminToken( {commit} ) {
      commit('resetAdminToken');
    }
  },
  getters: {
    sidebarMainState: state => state.sidebarMainExpanded,
    pageFixedState: state => state.pageFixed,

    dashRoleIdState: state => state.dashRoleId,
    partnerIdState: state => state.partnerId,

    cardFixedState: state => state.cardFixed,
    headerExpandedState: state => state.headerExpanded,
    offcanvasState: state => state.offcanvasExpanded,
    getAuthUser: state => state.auth['name'],
    getAuthUserStatus: state => state.auth['status'],
    getAuthUserFullName: state => state.auth['first_name']+' '+state.auth['last_name'],
    getAuthUserRole: state => state.auth['role'],
    getAuthUserRoleId: state => state.auth['role_id'],
    getAuthUserId: state => state.auth['id'],
    getConfig: (state) => (name) => {
      return state.config[name];
    },
    getNewPartner: state => state.isNewPartner,
    getAdminToken: state => state.sauthToken

  },
  plugins: [
    createPersistedState({
      key: 'trexova',
    })
  ]
});

export default store;



// WEBPACK FOOTER //
// ./src/store.js